const animatedTags = document.querySelectorAll('div.promobar-mobile, div.promobar-large, div.announcement-bar-with-link, header.page-header-large, section:not(.spacer), div.content-wrap, div.product-page, div.faq-terms-module, div.faq-cookie-module, div.faq-delivery-module, div.faq-privacy-module, div.content-module, div.page-care-guide, div.page-care-guide-detail, div.page-press, div.page-press-detail, div.page-stores, div.page-stores-detail, div.page-wishlist, div.product-card-hero, div.content-block-collection, div.product-card, div.card-banner, div.card-banner-new, div.content-block-product, div.product-card-highlight, section.faqs, section.related-products-module, div.filter-bar')

// Benefits bar containers need special handling for sequential animation
const benefitsBarContainers = document.querySelectorAll('.benefits-bar-module .benefits-bar-container, .benefits-bar-module-new .benefits-bar-container')

// Track elements that have already been animated so they are never re-triggered on scroll
const animatedOnce = new Set()

// fade out on load — skip the fixed header so it never becomes transparent
animatedTags.forEach(tag => {
    if (!tag.matches('header.page-header-large')) {
        tag.style.opacity = 0;
    }
})

// fade out benefits bar containers on load
benefitsBarContainers.forEach(container => {
    container.style.opacity = 0;
})


const fadeIn = function() {
   // look through all the animated tags and see
   // width the getBoundingClientRect if it's in the window

let delay = 0.10

animatedTags.forEach(tag => {
    if (animatedOnce.has(tag)) return;

    const tagTop = tag.getBoundingClientRect().top
    const tagBottom = tag.getBoundingClientRect().bottom

   if (tagTop < window.innerHeight && tagBottom > 0 ) {
       // Fixed header: fade in immediately with no delay so it never exposes content behind it
       if (tag.matches('header.page-header-large')) {
           tag.style.animation = 'fadeInOnly 0.4s 0s both'
           animatedOnce.add(tag)
           return;
       }
       // project-list-small* sections always use fadeInOnly: cards animate
       // individually via animate-in CSS transitions, so translateY on the
       // wrapper overflows into adjacent sections and doubles the motion.
       const isProjectList = [...tag.classList].some(c => c.startsWith('project-list-small'));
       const animName = isProjectList ? 'fadeInOnly' : 'moveElement';
       tag.style.animation = `${animName} 1s ${delay}s both`
       animatedOnce.add(tag)
       delay = delay + 0.05
   }

   })

   // Animate benefits bar containers sequentially
   let benefitsDelay = 0.10
   benefitsBarContainers.forEach(container => {
       if (animatedOnce.has(container)) return;

       const containerTop = container.getBoundingClientRect().top
       const containerBottom = container.getBoundingClientRect().bottom

       if (containerTop < window.innerHeight && containerBottom > 0) {
           container.style.animation = `moveElement 1s ${benefitsDelay}s both`
           animatedOnce.add(container)
           benefitsDelay = benefitsDelay + 0.15
       }
   })

}

// On load, run fadeIn
fadeIn()

// On scroll, run fadeIn
document.addEventListener("scroll", function(){
   fadeIn()
})

// On browser resize, run fadeIn
window.addEventListener("resize", function(){
   fadeIn()
})

// GSAP animation for Xmas illustration
window.addEventListener('load', function() {
   if (typeof gsap !== 'undefined') {
      var illustration = document.querySelector('.xmas-image-copy__illustration-image');
      if (illustration) {
         console.log('Starting GSAP floating animation!');
         // Floating animation (up and down)
         gsap.to(illustration, {
            y: -15,
            duration: 2.5,
            repeat: -1,
            yoyo: true,
            ease: "power1.inOut"
         });

         // Subtle rotation
         gsap.to(illustration, {
            rotation: 3,
            duration: 3,
            repeat: -1,
            yoyo: true,
            ease: "sine.inOut"
         });
      } else {
         console.log('Illustration not found');
      }

      // GSAP animation for Xmas Immersive Collection stars
      var stars = document.querySelectorAll('.xmas-immersive-collection__star');
      if (stars.length > 0) {
         // Create a timeline for sequential animation
         var timeline = gsap.timeline({ repeat: -1 });

         stars.forEach(function(star, index) {
            // Add each star animation to the timeline with a stagger
            timeline.to(star, {
               opacity: 0.3,
               duration: 2.5,
               ease: "power1.inOut"
            }, index * 0.4) // Stagger by 0.4 seconds
            .to(star, {
               opacity: 1,
               duration: 2.5,
               ease: "power1.inOut"
            }, index * 0.4 + 2.5); // Fade back after the same delay + duration
         });
      }

      // GSAP animation for Xmas Central Block illustrations
      var moonIllustration = document.querySelector('.xmas-central-block__illustration--moon');
      var starIllustration = document.querySelector('.xmas-central-block__illustration--star');

      if (moonIllustration) {
         // Moon floating animation
         gsap.to(moonIllustration, {
            y: -12,
            duration: 3,
            repeat: -1,
            yoyo: true,
            ease: "power1.inOut"
         });

         // Subtle rotation for moon
         gsap.to(moonIllustration, {
            rotation: 5,
            duration: 4,
            repeat: -1,
            yoyo: true,
            ease: "sine.inOut"
         });
      }

      if (starIllustration) {
         // Star floating animation with different timing
         gsap.to(starIllustration, {
            y: -15,
            duration: 2.5,
            repeat: -1,
            yoyo: true,
            ease: "power1.inOut",
            delay: 0.5
         });

         // Subtle rotation for star
         gsap.to(starIllustration, {
            rotation: -8,
            duration: 3.5,
            repeat: -1,
            yoyo: true,
            ease: "sine.inOut"
         });
      }

      // GSAP animation for Xmas Hotel Module images
      var leftImage = document.querySelector('.xmas-hotel-left-column .xmas-hotel-image');
      var rightImage = document.querySelector('.xmas-hotel-right-column .xmas-hotel-image');

      // Set initial state - hide images
      if (leftImage) {
         gsap.set(leftImage, {
            clipPath: 'inset(100% 0% 0% 0%)',
            opacity: 1
         });
      }

      if (rightImage) {
         gsap.set(rightImage, {
            clipPath: 'inset(0% 0% 100% 0%)',
            opacity: 1
         });
      }

      // Create observer for scroll animation
      var hotelModule = document.querySelector('.xmas-hotel-module');
      if (hotelModule) {
         var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
               if (entry.isIntersecting) {
                  // Left image grows from bottom
                  if (leftImage) {
                     gsap.to(leftImage, {
                        clipPath: 'inset(0% 0% 0% 0%)',
                        duration: 0.8,
                        ease: "power2.out"
                     });
                  }

                  // Right image grows from top
                  if (rightImage) {
                     gsap.to(rightImage, {
                        clipPath: 'inset(0% 0% 0% 0%)',
                        duration: 0.8,
                        ease: "power2.out",
                        delay: 0.6
                     });
                  }

                  observer.unobserve(entry.target);
               }
            });
         }, { threshold: 0.2 });

         observer.observe(hotelModule);
      }

      // GSAP animation for Hotel Module illustration lights - "Arriving Home" effect
      var illustrationLights = document.querySelector('.xmas-hotel-illustration-lights');

      if (illustrationLights) {
         var hotelModuleForLights = document.querySelector('.xmas-hotel-module');

         if (hotelModuleForLights) {
            var lightsObserver = new IntersectionObserver(function(entries) {
               entries.forEach(function(entry) {
                  if (entry.isIntersecting) {
                     // Sequential "arriving home" lights animation
                     var timeline = gsap.timeline();

                     // Start with lights off
                     gsap.set(illustrationLights, { opacity: 0 });

                     // First room/window - bottom left area (simulate entering the house)
                     timeline
                        .to(illustrationLights, {
                           opacity: 0,
                           duration: 0,
                           delay: 1
                        })
                        .to(illustrationLights, {
                           clipPath: 'polygon(0% 60%, 35% 60%, 35% 100%, 0% 100%)',
                           opacity: 0.2,
                           duration: 0.05
                        })
                        .to(illustrationLights, {
                           opacity: 0,
                           duration: 0.03
                        })
                        .to(illustrationLights, {
                           opacity: 1,
                           duration: 0.15
                        })
                        // Second room/window - bottom right
                        .to(illustrationLights, {
                           clipPath: 'polygon(0% 60%, 70% 60%, 70% 100%, 0% 100%)',
                           duration: 0.4
                        })
                        .to(illustrationLights, {
                           opacity: 0.3,
                           duration: 0.05
                        })
                        .to(illustrationLights, {
                           opacity: 1,
                           duration: 0.15
                        })
                        // Upper floor windows
                        .to(illustrationLights, {
                           clipPath: 'polygon(0% 20%, 100% 20%, 100% 100%, 0% 100%)',
                           duration: 0.5
                        })
                        .to(illustrationLights, {
                           opacity: 0.4,
                           duration: 0.05
                        })
                        .to(illustrationLights, {
                           opacity: 1,
                           duration: 0.15
                        })
                        // All lights on
                        .to(illustrationLights, {
                           clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
                           duration: 0.6,
                           ease: "power1.out"
                        });

                     lightsObserver.unobserve(entry.target);
                  }
               });
            }, { threshold: 0.3 });

            lightsObserver.observe(hotelModuleForLights);
         }
      }

      // GSAP animation for Benefits Bar SVG drawing effect
      var benefitsBarSvgs = document.querySelectorAll('.benefits-bar-svg[data-animate-draw="true"]');

      if (benefitsBarSvgs.length > 0) {
         console.log('Found', benefitsBarSvgs.length, 'SVG containers to animate');

         benefitsBarSvgs.forEach(function(svgContainer) {
            var svgUrl = svgContainer.getAttribute('data-svg-url');
            console.log('SVG URL:', svgUrl);

            if (svgUrl) {
               // Fetch and load the SVG file
               fetch(svgUrl)
                  .then(function(response) {
                     if (!response.ok) throw new Error('SVG not found at: ' + svgUrl);
                     return response.text();
                  })
                  .then(function(svgContent) {
                     console.log('SVG loaded successfully');
                     // Inject SVG content
                     svgContainer.innerHTML = svgContent;

                     // Wait for next frame to ensure DOM is updated
                     requestAnimationFrame(function() {
                        // Initialize animation after SVG is loaded
                        initializeSvgAnimation(svgContainer);
                     });
                  })
                  .catch(function(error) {
                     console.error('Error loading SVG:', error);
                  });
            } else {
               console.log('No SVG URL found, checking for inline SVG');
               // SVG already in DOM (for backward compatibility)
               initializeSvgAnimation(svgContainer);
            }
         });
      } else {
         console.log('No SVG containers found for animation');
      }

      function initializeSvgAnimation(svgContainer) {
         var svg = svgContainer.querySelector('svg');
         if (!svg) {
            console.log('No SVG element found in container');
            return;
         }

         console.log('SVG element found, initializing animation');

         var paths = svg.querySelectorAll('path');
         if (paths.length === 0) {
            console.log('No paths found in SVG');
            return;
         }

         console.log('Found', paths.length, 'paths to animate');

         // Set up paths for drawing animation
         paths.forEach(function(path, index) {
            var length = path.getTotalLength();
            console.log('Path', index, 'length:', length);
            // Set initial state - path invisible
            gsap.set(path, {
               strokeDasharray: length,
               strokeDashoffset: length,
               opacity: 1
            });
         });

         // Create intersection observer for scroll trigger
         var benefitsBarModule = svgContainer.closest('.benefits-bar-module');
         if (benefitsBarModule) {
            console.log('Setting up intersection observer');
            var svgObserver = new IntersectionObserver(function(entries) {
               entries.forEach(function(entry) {
                  if (entry.isIntersecting) {
                     console.log('Benefits bar is visible, starting animation');
                     // Get the container's delay from the existing animation
                     var container = svgContainer.closest('.benefits-bar-container');
                     var allContainers = Array.from(benefitsBarModule.querySelectorAll('.benefits-bar-container'));
                     var containerIndex = allContainers.indexOf(container);
                     var delay = 0.10 + (containerIndex * 0.15);

                     console.log('Animation delay:', delay);

                     // Animate each path drawing in
                     paths.forEach(function(path, index) {
                        gsap.to(path, {
                           strokeDashoffset: 0,
                           duration: 1.2,
                           ease: "power2.inOut",
                           delay: delay + (index * 0.1)
                        });
                     });

                     svgObserver.unobserve(entry.target);
                  }
               });
            }, { threshold: 0.3, rootMargin: '0px 0px -100px 0px' });

            svgObserver.observe(benefitsBarModule);
         }
      }
   } else {
      console.log('GSAP not loaded');
   }
});




// Image change
// mainImg = document.getElementById("myImg");
// thumb1 = document.getElementById("thumbnail");
// thumb1Src = thumb1.src

// thumb1.addEventListener("click", function () {
//   alert(thumb1Src)
//    mainImg.src = thumb1Src;
// })


// Dead jQuery block removed — jQuery isn't loaded (see theme.liquid), and thumbnail-to-
// hero image swapping is already handled in application-vanilla.js without it.

  
   //document.querySelectorAll("div.thumbnail").click(function () {
   //alert('dás');
    //let plaatje = this.attr("src");
    //document.getElementById("grote_image").attr("src",plaatje);
    
   //})
  


//    document.querySelectorAll("div.thumbnail").forEach(elem => elem.addEventListener("click",
//  () => {
    
//     var selectedImage = elem(src)
//     alert(selectedImage);


   
//     }));
